import { render, staticRenderFns } from "./answerList.vue?vue&type=template&id=1d782a26"
import script from "./answerList.vue?vue&type=script&lang=ts"
export * from "./answerList.vue?vue&type=script&lang=ts"
import style0 from "./answerList.vue?vue&type=style&index=0&id=1d782a26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports